import axios from 'axios';

/** global wpiApiUrl */
export default axios.create( {
	baseURL: wpiApiUrl,
} );
